module.exports = __webpack_public_path__ + "static/img/wa.2b58581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wa.png
// module id = 7KbZ
// module chunks = 45